export const routes = {
  user_module_newsletterManager_home: {
    path: `newsletter-manager/:moduleBridgeHex/home/:page/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
    },
  },
};
